import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider, RecaptchaVerifier, signInWithPhoneNumber, signInWithPopup } from "firebase/auth";
import API from "./api";

let firebaseApp;

const firebaseConfig = {
  apiKey: "AIzaSyDFDip5ENBC23f40YQFhzJxuPfY2PG_TSQ",
  authDomain: "mkings-dd77e.firebaseapp.com",
  projectId: "mkings-dd77e",
  storageBucket: "mkings-dd77e.firebasestorage.app",
  messagingSenderId: "316073499492",
  appId: "1:316073499492:web:a92bd0f2f5650357ceb871",
  measurementId: "G-J6X7JYWV94"
};

async function getAuthInstance() {
  firebaseApp = getApps()[0] || initializeApp(firebaseConfig);
  return getAuth(firebaseApp);
}

export async function isFirebasePhoneAuthReady() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId);
}

export async function sendFirebasePhoneOtp(phone) {
  const ready = await isFirebasePhoneAuthReady();
  if (!ready) {
    throw new Error("Firebase phone OTP is not configured");
  }

  const auth = await getAuthInstance();
  const containerId = "firebase-recaptcha-container";
  resetFirebasePhoneOtp();

  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement("div");
    container.id = containerId;
    document.body.appendChild(container);
  }
  container.style.cssText = "position:fixed;right:0;bottom:0;width:70px;height:70px;opacity:.01;overflow:hidden;pointer-events:none;z-index:2147483647;";

  window.firebaseRecaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
    size: "invisible",
  });
  await window.firebaseRecaptchaVerifier.render();

  return signInWithPhoneNumber(auth, `+91${phone}`, window.firebaseRecaptchaVerifier);
}

export async function verifyFirebasePhoneOtp(confirmationResult, otp) {
  const credential = await confirmationResult.confirm(otp);
  return credential.user.getIdToken();
}

export function resetFirebasePhoneOtp() {
  try {
    window.firebaseRecaptchaVerifier?.clear?.();
  } catch {
    // ignore stale verifier cleanup errors
  }
  window.firebaseRecaptchaVerifier = null;
  const container = document.getElementById("firebase-recaptcha-container");
  if (container) container.innerHTML = "";
}

export async function signInAdminWithGoogle(authCode = "") {
  const auth = await getAuthInstance();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const credential = await signInWithPopup(auth, provider);
  const idToken = await credential.user.getIdToken();
  const res = await API.post("/admin-login/google", { idToken, auth_code: authCode });
  return res.data;
}
